import React from "react";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { injectIntl } from "react-intl";
import { withRouter } from "../../../../shared/hoc/withRouter";

import BiDynamicForm from "../../../../partials/layout/BiDynamicForm";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";

import * as aiSettingsCrud from "../../../../crud/aisettings.crud";

const initialState = {
  companyAISettings: null,
  loading: true,
  saving: false,
};

class CompanyAISettings extends React.Component {
  constructor(props) {
    super(props);

    this.companyAISettingsFormConfig = {
      buttonText: props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_UPDATE" }),
      fields: [
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SUPPORT_ARTICLES" }),
          dataField: "supportarticles",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SUPPORT_ARTICLES_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.REACHBACK_DATA" }),
          dataField: "reachbackdata",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.REACHBACK_DATA_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SENTIMENT_ANALYSIS" }),
          dataField: "sentimentanalysis",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.SENTIMENT_ANALYSIS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.AI_SUMMARISATION" }),
          dataField: "aisummarisation",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.AI_SUMMARISATION_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.ATTACHMENTS" }),
          dataField: "attachments",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.ATTACHMENTS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.DOCUMENTS" }),
          dataField: "documents",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.DOCUMENTS_TOOLTIP" }),
          },
        },
        {
          label: props.intl.formatMessage({ id: "AISETTINGS.FIELD.USER_UPLOADS" }),
          dataField: "useruploads",
          editorType: "dxSwitch",
          editorOptions: {
            switchedOffText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" }),
            switchedOnText: props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" }),
            hint: props.intl.formatMessage({ id: "AISETTINGS.FIELD.USER_UPLOADS_TOOLTIP" }),
          },
        },
      ],
    };

    this.state = { ...initialState };
  }

  componentDidMount() {
    this.fetchAISettings();
  }

  fetchAISettings = () => {
    const companyId = this.props.params?.companyid;

    if (!companyId) {
      this.props.enqueueSnackbar("Missing company id in route params.", { variant: "error" });
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    aiSettingsCrud
      .GetAISettings("COMPANY", companyId)
      .then((resp) => {
        const dto = resp?.data || {};

        const companyAISettings = {
          type: dto.type ?? "COMPANY",
          referenceid: dto.referenceid ?? companyId,

          supportarticles: dto.supportarticles ?? false,
          reachbackdata: dto.reachbackdata ?? false,
          sentimentanalysis: dto.sentimentanalysis ?? false,
          aisummarisation: dto.aisummarisation ?? false,
          attachments: dto.attachments ?? false,
          documents: dto.documents ?? false,
          useruploads: dto.useruploads ?? false,
        };

        this.setState({ companyAISettings, loading: false });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(err?.toString?.() || "Failed to load AI settings.", { variant: "error" });
        this.setState({ loading: false });
      });
  };

  saveAISettings = (aiSettings, setSubmitting) => {
    this.setState({ saving: true });

    const payload = {
      ...aiSettings,
      type: aiSettings.type || "COMPANY",
      referenceid: aiSettings.referenceid || this.props.params.companyid,
    };

    aiSettingsCrud
      .SaveAISettings(payload)
      .then(() => {
        this.props.enqueueSnackbar(
          this.props.intl.formatMessage({ id: "AISETTINGS.UPDATE.SUCCESS" }),
          { variant: "success" }
        );


        this.fetchAISettings();

        if (setSubmitting) setSubmitting(false);
        this.setState({ saving: false });
      })
      .catch((err) => {
        this.props.enqueueSnackbar(err?.toString?.() || "Failed to save AI settings.", { variant: "error" });
        if (setSubmitting) setSubmitting(false);
        this.setState({ saving: false });
      });
  };

  render() {
    if (this.state.loading || !this.state.companyAISettings) {
      return <PortletSpinner />;
    }

    return (
      <Portlet>
        <PortletHeader title={this.props.intl.formatMessage({ id: "AISETTINGS.TITLE.COMPANY" })} />
        <PortletBody style={{ maxWidth: 800 }}>
          <BiDynamicForm
            item={this.state.companyAISettings}
            config={this.companyAISettingsFormConfig}
            onSubmitHandler={this.saveAISettings}
            disabled={this.state.saving}
          />
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = (store) => ({
  userProfile: store.auth.userProfile,
  company: store.company.company,
});

export default withRouter(injectIntl(withSnackbar(connect(mapStateToProps)(CompanyAISettings))));
